import { useQuery } from '@tanstack/react-query';
import { CLINIC_ON } from './edition.js';

/**
 * "Esta conta tem clínica?" para telas de sempre (Mudar o jeito mostra o jaleco só a quem
 * tem). Mesma chave que `useClinic` (`['clinic']`), então a resposta é compartilhada; o
 * cliente da clínica só entra no pacote quando o módulo está ligado (`CLINIC_ON`).
 */
export function useHasClinic(): boolean {
  const query = useQuery({
    queryKey: ['clinic'] as const,
    queryFn:
      import.meta.env.VITE_CLINIC === 'off'
        ? async () => null
        : () => import('./api/clinic.js').then((m) => m.getClinic()),
    staleTime: 60_000,
    retry: false,
    enabled: CLINIC_ON,
  });
  return !!query.data;
}
